import { createAction } from '@reduxjs/toolkit';
const prefix = 'sync';
export const syncActions = {
    state: createAction(`${prefix}/state`),
};
